import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/material';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
    colorScheme: {
      light: {
        primary: {
          color: 'rgb(47, 93, 228)',
          inverseColor: 'rgba(47, 93, 228,0.5)',
          hoverColor: 'rgba(47, 93, 228,0.5)',
        },
        highlight: {
          background: 'rgb(47, 93, 228,100)',
          focusBackground: 'rgb(47, 93, 228,100)',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
    },
  },
  components: {
    dialog: {
      background: '#ffffff',
    },
  },
});

export default MyPreset;
